import axiosClient from "./axiosClient";

export const preloadApi = {
  getPreload: () => {
    return axiosClient.post("/preload");
  },
};